import { CoachSkillType } from '../../../types/coachSkillCertifications';

const REQUIRED_DESIGN_SKILLS = [CoachSkillType.MOKUMOKU_DESIGN, CoachSkillType.EXAM_DESIGN];
const REQUIRED_WRITING_SKILLS = [CoachSkillType.MOKUMOKU_WRITING, CoachSkillType.EXAM_WRITING];
const REQUIRED_MARKETING_SKILLS = [CoachSkillType.MOKUMOKU_MARKETING, CoachSkillType.EXAM_MARKETING];
const REQUIRED_BRANDING_SKILLS = [CoachSkillType.EXAM_BRANDING];

// prettier-ignore
export const isAllowedToWatchDesignVideos = (currentUserSkillTypes: CoachSkillType[]) => REQUIRED_DESIGN_SKILLS.some((element) => currentUserSkillTypes.includes(element));
// prettier-ignore
export const isAllowedToWatchWritingVideos = (currentUserSkillTypes: CoachSkillType[]) => REQUIRED_WRITING_SKILLS.some((element) => currentUserSkillTypes.includes(element));
// prettier-ignore
export const isAllowedToWatchMarketingVideos = (currentUserSkillTypes: CoachSkillType[]) => REQUIRED_MARKETING_SKILLS.some(element => currentUserSkillTypes.includes(element))
// prettier-ignore
export  const isAllowedToWatchBrandingVideos = (currentUserSkillTypes: CoachSkillType[]) => REQUIRED_BRANDING_SKILLS.some(element => currentUserSkillTypes.includes(element))
